import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function CarvedLanternsPage() {
  return <ProductPageContent data={PRODUCT_PAGES["carved-lanterns"]} />;
}

export default CarvedLanternsPage;
